import React from 'react';

import CustomDropdown from '@components/CustomDropdown';

const AddNewFabricDropdown = ({
	label,
	title,
	toolTipLength = 18,
	items,
	fabricErrors,
	setSelectedFabricType,
	getFabricTypeName,
	selectedFabricType,
	isSubCategory = false,
	isDisabled = false,
	onFetchSubCategory
}) => {
	return (
		<div className="form-group mr-1">
			<div className="category-select position-relative">
				<label htmlFor="fabricType">{label}</label>
				<CustomDropdown
					isDisabled={isDisabled}
					type="addItem"
					title={title}
					toolTipLength={toolTipLength}
					onItemClick={(item) => {
						onFetchSubCategory && onFetchSubCategory();
						setSelectedFabricType(isSubCategory ? item : item.code);
					}}
					items={items}
					selectedItem={
						isSubCategory
							? getFabricTypeName(selectedFabricType)
							: getFabricTypeName(selectedFabricType)?.name
					}
				/>
				{fabricErrors && <p className="error">{fabricErrors}</p>}
			</div>
		</div>
	);
};

export default AddNewFabricDropdown;
